import styled from "@emotion/styled";
import { MdsItemListSectionHeaderRowData } from "@/design-system/components/item-list/types";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";
import { mdsPanelWidthsValue } from "@/design-system/foundations";

interface Props {
  data: MdsItemListSectionHeaderRowData;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsItemListSectionHeaderRow = ({ data }: Props) => {
  const { title } = data.payload;

  return (
    <Wrapper key={title}>
      <PrimaryText
        color={MDSTextColor.Secondary}
        variant={MDSTextVariant.TextXs}
        weight={MDSTextWeight.SemiBold}
      >
        {title}
      </PrimaryText>
    </Wrapper>
  );
};

const Wrapper = styled.header`
  padding-top: ${({ theme }) => theme.spacing["4"]};
  padding-bottom: ${({ theme }) => theme.spacing["2"]};
  padding-inline: ${({ theme }) => theme.spacing["7"]};
  user-select: none;

  @container mds-panel (max-width: ${mdsPanelWidthsValue.narrow}px) {
    padding-inline: ${({ theme }) => theme.spacing["2"]};
  }
`;

const PrimaryText = styled(MDSText)`
  letter-spacing: 0.24px;
  text-transform: uppercase;
`;
